var render = function render(){var _vm=this,_c=_vm._self._c;return _c('AdminNextIframe',{attrs:{"path":"/physical-stock/","with-currency":"","query":_vm.initialQuery},on:{"message":_vm.onIframeMessage}})
}
var staticRenderFns = []

export { render, staticRenderFns }